/**
 * Persist UTM / Referrer attribution data in a first-party cookie
 * so it is available during checkout (PHP reads the cookie).
 */

const COOKIE_NAME = 'vitalshop_utm_origin';
const COOKIE_MAX_AGE = 60 * 60 * 24 * 30; // 30 Tage

const ATTR_KEYS = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_term', 'utm_content'];

const isSecureContext = () => window.location.protocol === 'https:';

const readCookie = () => {
	try {
		const match = document.cookie.split('; ').find((row) => row.startsWith(`${COOKIE_NAME}=`));
		if (!match) {
			return null;
		}
		const value = decodeURIComponent(match.split('=')[1] || '');
		return JSON.parse(value);
	} catch (error) {
		console.warn('UTM Cookie parse failed', error);
		return null;
	}
};

const writeCookie = (data) => {
	try {
		const encoded = encodeURIComponent(JSON.stringify(data));
		let cookie = `${COOKIE_NAME}=${encoded};path=/;max-age=${COOKIE_MAX_AGE};SameSite=Lax`;
		if (isSecureContext()) {
			cookie += ';Secure';
		}
		document.cookie = cookie;
	} catch (error) {
		console.warn('UTM Cookie serialization failed', error);
	}
};

const buildPayloadFromUtm = (params) => {
	const hasUtm = ATTR_KEYS.some((key) => params.has(key));
	if (!hasUtm) {
		return null;
	}
	return {
		source: params.get('utm_source') || '',
		medium: params.get('utm_medium') || '',
		campaign: params.get('utm_campaign') || '',
		term: params.get('utm_term') || '',
		content: params.get('utm_content') || '',
		referrer: document.referrer || '',
		landing: window.location.href,
		ts: Date.now(),
	};
};

const guessAttributionFromReferrer = () => {
	const ref = document.referrer;
	if (!ref) {
		return {
			source: 'direct',
			medium: 'direct',
			campaign: '',
			term: '',
			content: '',
			referrer: '',
			landing: window.location.href,
			ts: Date.now(),
		};
	}

	try {
		const url = new URL(ref);
		const currentHost = window.location.hostname.replace(/^www\./, '');
		const refHost = url.hostname.replace(/^www\./, '');

		// Internal navigation → keine Überschreibung
		if (refHost === currentHost) {
			return null;
		}

		let source = refHost;
		let medium = 'referral';

		if (refHost.includes('google.')) {
			source = 'google';
			medium = 'organic';
		} else if (refHost.includes('bing.')) {
			source = 'bing';
			medium = 'organic';
		} else if (refHost.includes('yahoo.')) {
			source = 'yahoo';
			medium = 'organic';
		}

		return {
			source,
			medium,
			campaign: '',
			term: '',
			content: '',
			referrer: ref,
			landing: window.location.href,
			ts: Date.now(),
		};
	} catch (error) {
		return null;
	}
};

const shouldOverwrite = (existing, next) => {
	if (!existing) {
		return true;
	}
	if (!existing.ts) {
		return true;
	}
	return next.ts >= existing.ts;
};

const persistAttribution = () => {
	const params = new URLSearchParams(window.location.search);
	let payload = buildPayloadFromUtm(params);

	if (!payload) {
		payload = guessAttributionFromReferrer();
	}

	if (!payload) {
		return;
	}

	const existing = readCookie();
	if (!shouldOverwrite(existing, payload)) {
		return;
	}

	writeCookie(payload);
};

document.addEventListener('DOMContentLoaded', () => {
	try {
		persistAttribution();
	} catch (error) {
		console.warn('UTM attribution error', error);
	}
});


















